module.exports = __webpack_public_path__ + "static/media/klix-logo.3095bc01.svg";